import {Component, OnInit, ViewChild, Output, EventEmitter, ElementRef} from '@angular/core';
import {AuthService} from 'src/app/services/auth.service';
import {ToastrService} from 'ngx-toastr';
import {ActivatedRoute, Router} from '@angular/router';
import {JwtHelperService} from '@auth0/angular-jwt';
import {AlertService} from 'src/app/services/alert.service';
import {NgForm} from '@angular/forms';

import * as moment from 'moment';
import {SharedService} from 'src/app/shared-service/shared.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {
  @ViewChild('loginform') public loginform: NgForm;
  model: any = {};
  response2: any = [];
  org_code: any;
  resp_org_code: any;
  org_name: any;
  resp_org_name: any;
  response: any = [];
  loginModel: any = {};
  loginButtonName = 'Login';
  username: any;
  divlogin: boolean = true;
  divsignup: boolean = false;
  isprocessing: boolean = false;
  currenturl: any;
  permissionModel: any = {};
  static permissions: any = [];
  currentuser_loginId: any;
  savemodel: any = {};
  hide: boolean = true;

  constructor(
    private authService: AuthService,
    private toastrService: ToastrService,
    private router: Router,
    public jwtHelper: JwtHelperService,
    private alertService: AlertService,
    private sharedService: SharedService
  ) {
  }

  ngOnInit() {
    if (!this.jwtHelper.isTokenExpired()) {
      const userType = localStorage.getItem('type');
      if (userType == '0') {
        this.router.navigate(['/dashboard']);
      } else {
        this.router.navigate([localStorage.getItem('org_name').toLowerCase().replace(/''/g, '-') + '/dashboard']);
      }
      this.sharedService.tokenExpiredEvent.next('loggedIn');
    } else {
      delete localStorage.token;
      this.sharedService.tokenExpiredEvent.next('changed');
    }
  }

  signup(opt: any) {
    if (opt == 'signup') {
      this.divlogin = false;
      this.divsignup = false;
    } else {
      this.divlogin = true;
      this.divsignup = false;
    }
  }

  login() {
    if (!this.loginform.valid) {
      return;
    }
    this.isprocessing = true;
    this.loginButtonName = 'Please wait ...';
    this.authService.login(this.model).subscribe((doc: any) => {
        if (!doc.success) {
          this.alertService.errorAlert(doc.errorMessage);
          this.isprocessing = false;
          return;
        }
        this.loginModel = doc;
        //set flat design as default for evey user
        if (!localStorage.getItem('flatedesign')) {
          localStorage.setItem('flatedesign', 'on');
          if (!localStorage.getItem('skin_type')) {
            localStorage.setItem('skin_type', 'skin-4');
          }
        }
        if (this.loginModel && this.loginModel.doc && this.loginModel.doc) {

          localStorage.setItem('token', doc['token']);
          localStorage.setItem('username', this.loginModel.doc.username);
          localStorage.setItem('org_name', this.loginModel.doc.organization_name);
          localStorage.setItem('user_id', this.loginModel.doc._id);
          localStorage.setItem('role_name', this.loginModel.doc.role_name);
          localStorage.setItem('org_id', this.loginModel.org_id);
          localStorage.setItem('type', this.loginModel.doc.type);
          localStorage.setItem('passwordPolicy', JSON.stringify(this.loginModel.passwordPolicy));
          localStorage.setItem('authClients', JSON.stringify(this.loginModel.authorizedClients));
          localStorage.setItem('defaultClient', this.loginModel.defaultClient);
          if (document.getElementsByClassName('theme-config').length > 0) {
            (<any>document.getElementsByClassName('theme-config')[0]).hidden = false;
          }
          if ((<any>doc).preferences) {
            Object.entries((<any>doc).preferences).forEach(([key, value]) => {
              localStorage.setItem(key, <string>value);
            });
          }
          this.sharedService.tokenExpiredEvent.next('loggedIn');
          this.SaveLoginState();
          if (this.loginModel.type != '1') {
            this.router.navigate(['/dashboard']);
          } else {
            this.router.navigate([this.loginModel.doc.organization_name.toLowerCase().replace(/''/g, '-') + '/dashboard']);
          }
        }
      },
      error => {
        debugger;
        var errorMessage = error && error.error && error.error.message ? error.error.message : 'Sorry, Something went wrong!';
        this.alertService.errorAlert(errorMessage);
        this.loginButtonName = 'Login';
        this.isprocessing = false;
      }, () => {
        this.loginButtonName = 'Login';

        // this.getpermissions(this.loginModel.doc[0].username, this.loginModel.doc[0].application_code);
      });
  }

  getpermissions(username: any, application_code: any) {
    this.permissionModel.username = username;
    this.permissionModel.application_code = application_code;
    this.authService.getPermissionsByAppId(this.permissionModel).subscribe((res) => {
      LoginComponent.permissions = res;
      localStorage.setItem('permissions', JSON.stringify(LoginComponent.permissions.doc[1]));
      // this.SaveLoginState();
      // this.check_userpreference();
    }),
      error => {
        this.isprocessing = false;
      },
      () => {
        this.isprocessing = false;
      };
  }

  SaveLoginState() {
    // this.savemodel.is_active = false
    // this.savemodel.application_code = this.loginModel.doc[0].application_code
    // this.savemodel.application_id = this.loginModel.doc[0].application_id
    // this.savemodel.user_id = this.loginModel.doc[0]._id
    // this.savemodel.username = this.loginModel.doc[0].username
    // this.savemodel.log_in_date = moment(Date.now()).format('ddd MM-DD-YYYY hh:mm A')
    // this.authService.SaveBrowserState(this.savemodel).subscribe((res) => {
    //   this.currentuser_loginId = res["id"]
    //   localStorage.setItem('currentuser_loginId', this.currentuser_loginId)
    // }, error => {
    //   this.isprocessing = false;
    // }, () => {
    //  // this.router.navigate(['/dashboard']);
    // })
  }

  check_userpreference() {
    if (localStorage.getItem('username')) {
      this.model.username = localStorage.getItem('username');
    }
    this.authService.check_userpreference(this.model).subscribe((res) => {
      this.response = res;
    }, error => {
      this.isprocessing = false;
      console.log(error);
    }, () => {
      if (this.response.length > 0) {
        localStorage.setItem('org_code', this.response[0].organization_id);
        localStorage.setItem('resp_org_code', this.response[0].resp_org_id);
        localStorage.setItem('org_name', this.response[0].organization_name);
        localStorage.setItem('resp_org_name', this.response[0].resp_org_name);
        localStorage.setItem('IsAdmin', 'N');
        this.router.navigate(['/home']);
      } else {
        this.router.navigate(['organization-list']);
      }
    });
  }

  //register User
  // register() {
  //   // if (!this.signupform.valid) {
  //   //   return
  //   // }
  //   this.authService.register(this.model).subscribe((res) => {

  //   }, error => {

  //   }, () => {
  //     this.alertService.updateAlert("Registered Successfully");
  //     this.model = ""
  //     this.back_to_screen();
  //   })
  // }
  back_to_screen() {
    this.divlogin = true;
    this.divsignup = false;
  }
}
